// src/data/handbooks.js - RULING 302 (D7, ruling 278 item 7; Bob 2026-10-08: publish inside the platform, each role its own).
// The ONE map from a role to the handbook it may open. storage.rules enforces the same thing on the server
// (reference/handbook/<role claim>.pdf); this file only decides which link to show. Pure - no Firebase import -
// so scripts\test-handbooks.mjs can hold it to the rule.
const F = Object.freeze;

export const HANDBOOK_DIR = 'reference/handbook/';

export const HANDBOOKS = F({
  member:        F({ path: HANDBOOK_DIR + 'member.pdf',        label: 'Member handbook' }),
  local_chair:   F({ path: HANDBOOK_DIR + 'local_chair.pdf',   label: 'Local Chairperson handbook' }),
  general_chair: F({ path: HANDBOOK_DIR + 'general_chair.pdf', label: 'General Chairperson handbook' }),
});

// The handbooks this account may open: its own role's, or all three for the administrator. A tester or an
// account with no recognised role gets none (there is no tester handbook, and the rule would refuse it).
export function handbooksFor(user) {
  if (!user) return [];
  if (user.isAdmin || user.role === 'admin') return Object.values(HANDBOOKS);
  const h = HANDBOOKS[user.role];
  return h ? [h] : [];
}
